export const formValidator = {
  // rules
  rules: {
    required: function(value) {
      return "" !== value;
    },
    notzero: function(value) {
      return parseInt(value, 10) > 0;
    },
    integer: function(value) {
      return new RegExp(/^[0-9]+$/gi).test(value);
    },
    float: function(value) {
      value = value.toString().replace(/\,/, ".");
      return (
        this.integer(value) ||
        new RegExp(/^([0-9])+(\.)([0-9]+$)/gi).test(value)
      );
    },
    min: function(value, params) {
      if (this.float(value)) {
        return parseFloat(value) >= parseFloat(params[0]);
      }
      return parseInt(value, 10) >= parseInt(params[0], 10);
    },
    max: function(value, params) {
      if (this.float(value)) {
        return parseFloat(value) <= parseFloat(params[0]);
      }
      return parseInt(value, 10) <= parseInt(params[0], 10);
    },
    between: function(value, params) {
      params[1] = params[1] || 999999;

      if (this.float(value)) {
        return (
          parseFloat(value) >= parseFloat(params[0]) &&
          parseFloat(value) <= parseFloat(params[1])
        );
      }
      if (this.integer(value)) {
        return (
          parseInt(value, 10) >= parseInt(params[0], 10) &&
          parseInt(value, 10) <= parseInt(params[1], 10)
        );
      }
      return false;
    },
    name: function(value) {
      if (value.length > 0 && value.length < 2) {
        return false;
      }
      return new RegExp(/^[a-zA-Z\sа-яА-ЯёЁ\-]+$/g).test(value);
    },
    lastname: function(value) {
      return this.name(value);
    },
    phone: function(value) {
      if (
        value.replace(/[^0-9]+/gi, "").match(/[0-9]+/gi) &&
        value.replace(/[^0-9]+/gi, "").match(/[0-9]+/gi)[0].length < 6
      ) {
        return false;
      }
      return new RegExp(
        /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/g
      ).test(value);
    },
    email: function(value) {
      return new RegExp(
        /^(("[\w-\s]+")|([\w\-]+(?:\.[\w\-]+)*)|("[\w-\s]+")([\w\-]+(?:\.[\w\-]+)*))(@((?:[\w\-]+\.)*\w[\w\-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      ).test(value);
    },
    length: function(value, params) {
      return this.between(value.replace(/\s{2,}/g, " ").length, params);
    },
    maxlength: function(value, params) {
      return this.max(value.replace(/\s{2,}/g, " ").length, params);
    },
    minlength: function(value, params) {
      return this.min(value.replace(/\s{2,}/g, " ").length, params);
    },
    passwordmatch: function(value, element) {
      const form = getClosestParent(element, "form");
      const inputs = form.querySelectorAll('input[type="password"]');
      let allEqual = false;
      inputs.forEach(function(input) {
        input.value !== inputs[0].value
          ? (allEqual = false)
          : (allEqual = true);
      });

      return allEqual;
    }
  }
};

export function resetFormInputs(form) {
  form.querySelectorAll("input").forEach(function(input) {
    input.value = "";
  });
  form.querySelectorAll(".errors").forEach(function(el) {
    el.innerHTML = "";
  });
  form.querySelectorAll("select").forEach(function(select) {
    select.selectedIndex = -1;
    select.parentNode.querySelector("label").classList.remove("hide");
    form.querySelector(`[data-address-province-wrapper]`).classList.add("hide");
  });
}

export function attachValidator(element) {
  element.addEventListener("focus", focusHandler);
  element.addEventListener("focusout", focusoutHandler);
  element.addEventListener("keyup", keyupHandler);
  element.addEventListener("input", inputHandler);
}

function getClosestParent(element, selector) {
  for (; element && element !== document; element = element.parentNode) {
    if (element.matches(selector)) return element;
  }
  return null;
}

function focusHandler(e) {
  if (
    !e.target.getAttribute("class") ||
    e.target.getAttribute("class").indexOf("upper") < 0
  ) {
    e.target.classList.add("upper");
    e.target.parentElement.querySelector("label").classList.add("upper");
  }
  removeErrorMessage(e.target);
}

function focusoutHandler(e) {
  inputValidation(e.target);
}

function inputHandler(e) {
  if (e.target.id === 'CustomerPassword') {
    document.getElementById('CustomerPassword').value = e.target.value;
  }
  const form = getClosestParent(e.target, "form");
  checkInputValues(form);
}

function keyupHandler(e) {
  const form = getClosestParent(e.target, "form");
  checkInputValues(form);
}

function checkInputValues(form) {
  // Quick fix for form validation not working. In the future, we want to add class-selectors when an event listener is fired. 
  // Ex: On the form, we create input fields with classnames `input:invalid`. When an event listener is fired, the classname will be `input:valid`

  // let passed = [];
  // form.querySelectorAll("input[required]").forEach(function(input) {
  //   if (input.value.length > 0) {
  //     input.classList.add("filled");
  //     passed.push(input);
  //   } else {
  //     input.classList.remove("filled");
  //   }
  // });
  // if (passed.length == form.querySelectorAll("input[required]").length) {
    form.querySelector('button[type="submit"]') && form.querySelector('button[type="submit"]').removeAttribute("disabled");
    document.getElementById("registerButton") && document.getElementById("registerButton").removeAttribute("disabled");
  // } else {
  //   form.querySelector('button[type="submit"]') && form.querySelector('button[type="submit"]').setAttribute("disabled", "disabled");
  //   document.getElementById("registerButton") && document.getElementById("registerButton").setAttribute("disabled", "disabled");
  // }
}

function inputValidation(input) {
  if (
    input.getAttribute("class") &&
    input.getAttribute("class").indexOf("upper") > -1 &&
    input.value.length == 0
  ) {
    input.classList.remove("upper");
    input.parentElement.querySelector("label").classList.remove("upper");
  }

  if (input.value.length > 0) {
    input.classList.add("upper");
    input.parentElement.querySelector("label").classList.add("upper");
  }
}

function validate(input) {
  const rules = input.getAttribute("data-rule").split("|") || [];
  let results = [];

  Object.keys(rules).forEach(function(ruleIndex) {
    const rule = rules[ruleIndex].split("-");
    if (rule[0] === "passwordmatch") {
      results.push(formValidator.rules[rule[0]](input.value, input));
    } else {
      results.push(formValidator.rules[rule[0]](input.value, rule[1]));
    }
  });

  const foundFail = results.find(function(result) {
    return result === false;
  });

  const final = typeof foundFail === "undefined" ? true : false;
  return final;
}

function checkIfFormIsValid(form) {
  let passed = [];
  form.querySelectorAll("input[required]").forEach(function(input) {
    if (input.hasAttribute("valid")) {
      passed.push(input);
    }
  });

  if (passed.length == form.querySelectorAll("input[required]").length) {
    form.querySelector('button[type="submit"]').removeAttribute("disabled");
  } else {
    form
      .querySelector('button[type="submit"]')
      .setAttribute("disabled", "disabled");
  }
}

function errorMessage(input) {
  input.classList.add("error");
  input.parentElement.querySelector("label").classList.add("error");
  if (
    input.name === "affirmPassword" ||
    input.name === "customer[password_confirmation]"
  ) {
    input.parentElement
      .querySelector(".passwords-not-matching")
      .classList.remove("hide");
  }
}

function removeErrorMessage(input) {
  input.classList.remove("error");
  input.parentElement.querySelector("label").classList.remove("error");
  if (
    input.name === "affirmPassword" ||
    input.name === "customer[password_confirmation]"
  ) {
    input.parentElement
      .querySelector(".passwords-not-matching")
      .classList.add("hide");
  }
}

export function validateOnSubmit(form) {
  let passed = [];
  form.querySelectorAll("input[required]").forEach(function(input) {
    const isValid = validate(input);
    if (isValid) {
      passed.push(input);
      removeErrorMessage(input);
      input.setAttribute("valid", "valid");
    }
    if (!isValid) {
      errorMessage(input);
      input.removeAttribute("valid");
    }
  });
  if (passed.length != form.querySelectorAll("input[required]").length) {
    return false;
  }

  return true;
}
